<template>
  <div class="main">
    <img class="notice-img" src="@/assets/notion-ic.png" />
    <p class="text-line1">인터넷 연결</p>
    <p class="text-line2">인터넷 연결을 확인 후 앱을 다시 실행해 주세요</p>
    <div class="btn-area">
      <button
        class="home-btn"
        :class="{ focused: focusIndex == 1 }"
        @click="goHome"
      >
        홈으로
      </button>
      <button
        class="close-btn"
        :class="{ focused: focusIndex == 2 }"
        @click="enterKeyProc"
        ref="button"
      >
        종료하기
      </button>
    </div>
  </div>
</template>

<script>
import * as deviceApi from "../api/smartTv.js";
import * as websocket from "@/api/ws.js";

export default {
  data() {
    return {
      isActiveVue: true,
      focusIndex: 1,
    };
  },
  computed: {
    keyInput() {
      return this.$store.getters.keyInput;
    },
  },

  watch: {
    keyInput(val, oldVal) {
      if (this.isActiveVue) {
        switch (val.key) {
          case "Enter":
            if (this.focusIndex === 1) {
              this.goHome();
            } else {
              // 앱 종료
              this.enterKeyProc(val);
            }
            break;
          case "ArrowLeft":
            this.focusIndex = 1;
            break;
          case "ArrowRight":
            this.focusIndex = 2;
            break;
        }
      }
    },
  },

  methods: {
    enterKeyProc(keyInput) {
      deviceApi.stopApplication();
    },
    goHome() {
      this.$store.commit("SET_USER_INFO", {});
      this.$router.replace({
        name: "intro",
        params: {
          t: new Date().getTime(),
        },
      });
    },
  },

  created() {
    // this.$store.dispatch("REQUEST_LOGOUT");
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.main {
  margin-top: 310px;
  text-align: center;
}
.notice-img {
  width: 128px;
  height: 128px;
}
.text-line1 {
  font-size: 56px;
  line-height: 1;
  color: #eeeeee;
  margin: 40px 0;
}
.text-line2 {
  font-size: 28px;
  line-height: 1;
  color: #888888;
}

.btn-area {
  display: flex;
  justify-content: center;
}

button {
  width: 272px;
  height: 80px;
  background-color: #3e3e3e;
  font-size: 28px;
  color: #eeeeee;
  margin-top: 88px;
  border: none;
}

.close-btn {
  margin-left: 40px;
}

button.focused {
  border: solid 4px #eeeeee;
}

@media all and (min-width: 0px) and (max-width: 1280px) {
  .main {
    margin-top: 218px;
  }
  .notice-img {
    width: 64px;
    height: 64px;
  }
  .text-line1 {
    font-size: 32px;
    line-height: 1;
    color: #ffffff;
    margin: 40px 0 24px;
    font-weight: bold;
  }
  .text-line2 {
    font-size: 20px;
    line-height: 1;
    color: #888888;
  }
  button {
    width: 160px;
    height: 56px;
    background-color: #3e3e3e;
    font-size: 18px;
    color: #ffffff;
    margin-top: 48px;
    border: none;
  }

  .close-btn {
    margin-left: 20px;
  }

  button.focused {
    border: solid 3px #eeeeee;
  }
}
</style>
